import React, { useEffect, useState, useRef, forwardRef, Ref } from 'react'
import style from './index.module.scss'
import { SendOutlined } from '@ant-design/icons'
import send from './send.png';
import close from './close.png';
import { message } from 'antd';

import AtInput from "./AtInput"

interface Props {
    onSend?: any;
    list?: any[];
    quotes?: any[];
    reply?: any;
    removereply?: any;
    removequote?: any;
    ref?: any;
}

interface State {
}

const MsgInput = forwardRef((props: Props, ref: any) => {
    const [state, setState] = useState<State>({

    });
    const [content, setcontent] = useState<string>('');

    const render = (
        <div className={style.msginputout}>
            {
                (props.reply || (props.quotes && props.quotes.length)) ?
                    <div className={style.msginputtopline}>
                    </div> : null
            }
            {
                (props.reply || (props.quotes && props.quotes.length)) ?
                    <div className={style.msginputtop}>
                        {
                            props.reply ?
                                <div className={style.msginputreply}>
                                    <div className={style.msginputreplytitle}>
                                        回复<div className={style.msginputreplyhigh}>
                                            {props.reply.name || '开发团队'}
                                        </div>的话：
                                        <div className={style.msginputclose}>
                                            <img src={close}
                                                onClick={() => {
                                                    props.removereply(props.reply);
                                                }} />
                                        </div>
                                    </div>
                                    <div className={style.msginputreplycontent}>
                                        {
                                            props.reply.content &&
                                            props.reply.content[0] &&
                                            props.reply.content[0].mime === "text/plain" &&
                                            props.reply.content[0].value
                                        }
                                    </div>
                                </div> : null
                        }
                        {
                            (props.quotes && props.quotes.length) ?
                                (props.quotes || []).map((v: any, k: number) => {
                                    return (
                                        <div className={style.msginputreply}
                                            key={k}>
                                            <div className={style.msginputreplytitle}>
                                                引用<div className={style.msginputreplyhigh}>
                                                    {v.name || '开发团队'}
                                                </div>的话：
                                                <div className={style.msginputclose}
                                                >
                                                    <img src={close}
                                                        onClick={() => {
                                                            props.removequote(v);
                                                        }} />
                                                </div>
                                            </div>
                                            <div className={style.msginputreplycontent}>
                                                {
                                                    v.content &&
                                                    v.content[0] &&
                                                    v.content[0].mime === "text/plain" &&
                                                    v.content[0].value
                                                }
                                            </div>
                                        </div>
                                    )
                                }) : null
                        }
                    </div> : null
            }
            <div >
                <AtInput ref={ref} onSend={(_e: any) => {
                    props.onSend && props.onSend(_e);
                }} />
                {/* <textarea
                    ref={ref}
                    value={content}
                    className={style.input}
                    placeholder={'发表评论'}
                    onKeyDown={(e) => {
                        if (e.ctrlKey && e.code === 'Enter') {
                            if (!content) {
                                message.error('请输入内容');
                                return;
                            }
                            setcontent('');
                            props.onSend && props.onSend(content);
                        }
                    }}
                    onChange={(e) => {
                        setcontent(e.target.value)
                    }} />
                <div
                    className={style.icon + ' ' + (content.length === 0 ? style.disable : '')}
                    onClick={() => {
                        if (!content) {
                            message.error('请输入内容');
                            return;
                        }
                        setcontent('');
                        props.onSend && props.onSend(content);
                    }}>
                    <img src={send} />
                </div> */}
            </div>
        </div>
    )

    return render
})

export default MsgInput
